import { render } from "./AddDetails.vue?vue&type=template&id=098968fc&scoped=true"
import script from "./AddDetails.vue?vue&type=script&lang=js"
export * from "./AddDetails.vue?vue&type=script&lang=js"

import "./AddDetails.vue?vue&type=style&index=0&id=098968fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-098968fc"]])

export default __exports__